import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Lightweight "what the sidebar will look like" preview, rendered from the
 * current (unsaved) tree so users get immediate feedback while building.
 */
function PreviewNode({ node, depth }) {
  const children = node.menunavstructure_list || [];
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 0.6,
          pl: 1.5 + depth * 1.75,
          pr: 1,
          borderRadius: 1,
          color: depth === 0 ? "text.primary" : "text.secondary",
          fontWeight: depth === 0 ? 600 : 400,
          fontSize: depth === 0 ? 14 : 13,
          "&:hover": { bgcolor: "action.hover" },
        }}
      >
        {node.MenuNavItem_Icon ? (
          <i
            className={node.MenuNavItem_Icon}
            style={{ width: 16, textAlign: "center", opacity: 0.85 }}
          />
        ) : (
          <Box sx={{ width: 16 }} />
        )}
        <span>{node.MenuNavItem_Name || "Untitled"}</span>
      </Box>
      {children.map((child) => (
        <PreviewNode key={child.Id} node={child} depth={depth + 1} />
      ))}
    </Box>
  );
}

export default function MenuPreview({ tree }) {
  return (
    <Box
      sx={{
        bgcolor: "background.default",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 1,
        minHeight: 120,
      }}
    >
      <Typography
        variant="overline"
        sx={{ px: 1, color: "text.disabled", letterSpacing: 1 }}
      >
        Sidebar preview
      </Typography>
      {(!tree || tree.length === 0) && (
        <Typography variant="body2" sx={{ p: 2, color: "text.disabled" }}>
          Nothing here yet — add items to see the preview.
        </Typography>
      )}
      {(tree || []).map((node) => (
        <PreviewNode key={node.Id} node={node} depth={0} />
      ))}
    </Box>
  );
}
